module.exports = __webpack_public_path__ + "chipi-coupons.4642d0cb.png";